import CheckboxField from '../../components/CheckboxField';
import SmallHelpText from '../../components/SmallHelpText';
import { checkCloseTicket } from '../../actions/PanelActions';
import { useAppDispatch, useAppSelector } from '../../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CloseTicketField() {
  const dispatch = useAppDispatch();
  const ticket = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticket);
  const checked = useAppSelector(({
    zorseGrrTagging: state
  }) => state.panelState.closeTicketCheckedByTicketId.get(state.ticket.id, true));
  const helpLangPath = ticket.isResolved ? 'app.panel.body.fields.help.ticketClosed' : 'app.panel.body.fields.help.closeTicket';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CheckboxField, {
      "data-test-id": "checkbox-test-id",
      helpLangPath: helpLangPath,
      isDisabled: ticket.isResolved,
      labelLangPath: "app.panel.body.fields.labels.closeTicket",
      onCheckedChanged: value => dispatch(checkCloseTicket(ticket.id, value)),
      value: ticket.isResolved ? false : checked
    }), ticket.isResolved && /*#__PURE__*/_jsx(SmallHelpText, {
      textLangPath: helpLangPath
    })]
  });
}
export default CloseTicketField;